import { CustomModelPresets } from "../constants/customModel";

export type CustomModelPreset = (typeof CustomModelPresets)[number];
export function isCustomModelPreset(x: any): x is CustomModelPreset {
  return CustomModelPresets.includes(x);
}
